(function () {
  'use strict';

  function clean(value) {
    return String(value || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function yearOf(value) {
    var n = parseInt(value, 10);
    return Number.isFinite(n) ? n : 0;
  }

  function uniq(values) {
    var seen = {};
    return (values || []).filter(function (value) {
      var key = clean(value);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function includesAny(text, values) {
    text = clean(text);
    return (values || []).some(function (value) { return text.indexOf(clean(value)) !== -1; });
  }

  function isGM(make) {
    return includesAny(make, ['chevrolet', 'chevy', 'gmc', 'cadillac', 'pontiac', 'buick', 'hummer', 'saab', 'oldsmobile', 'isuzu', 'holden', 'hsv']);
  }

  function isMopar(make) {
    return includesAny(make, ['ram', 'dodge', 'chrysler', 'jeep']);
  }

  function engineHas(ctx, values) {
    return includesAny(ctx.engine, values);
  }

  function modelHas(ctx, values) {
    return includesAny(ctx.model, values);
  }

  function modelIs(ctx, values) {
    var model = clean(ctx.model);
    return (values || []).some(function (value) { return model === clean(value); });
  }

  function withUnknown(values) {
    return uniq(values).concat(["Not Listed / Don't Know"]);
  }

  function result(transmissions, drivetrains, exact) {
    return {
      transmissions: withUnknown(transmissions && transmissions.length ? transmissions : ['Automatic', 'Manual']),
      drivetrains: withUnknown(drivetrains || []),
      exact: exact !== false
    };
  }

  function gmPickupDrives(ctx, heavyDuty) {
    var group = clean(ctx.groupId);

    if (group === 'gen3 gm truck suv') {
      return heavyDuty ? [
        'RWD / 4x2',
        '4WD / 4x4 — NVG 261 (NP2 Manual Shift)',
        '4WD / 4x4 — NVG 263 (NP1 Electric Shift)'
      ] : [
        'RWD / 4x2',
        '4WD / 4x4 — NVG 261 (NP2 Manual Shift)',
        '4WD / 4x4 — NVG 263 (NP1 Electric Shift)',
        'Auto 4WD — NVG 246 (NP8 AutoTrac)'
      ];
    }

    if (group === 'gen4 gm truck suv') {
      return heavyDuty ? [
        'RWD / 4x2',
        '4WD / 4x4 — MP 1222/1225/1226 (NQG Manual Shift)',
        '4WD / 4x4 — MP 1625/1626 (NQF Electric Shift)'
      ] : [
        'RWD / 4x2',
        '4WD / 4x4 — MP 1222/1225/1226 (NQG Manual Shift)',
        'Auto 4WD — MP 3023/3024 (NQH AutoTrac)'
      ];
    }

    if (group === 'gen5 gm truck suv') {
      return heavyDuty ? [
        'RWD / 4x2',
        '4WD / 4x4 — NQF 2-Speed Electric Shift'
      ] : [
        'RWD / 4x2',
        '4WD / 4x4 — NQG 2-Speed Manual Shift',
        'Auto 4WD — NQH 2-Speed AutoTrac'
      ];
    }

    if (group === 'gen5 gm truck suv 2019 plus') {
      return heavyDuty ? [
        'RWD / 4x2',
        '4WD / 4x4 — NQF 2-Speed Electric Shift',
        'Auto 4WD — NQH 2-Speed Active'
      ] : [
        'RWD / 4x2',
        '4WD / 4x4 — Single-Speed AutoTrac',
        'Auto 4WD — NQH 2-Speed AutoTrac'
      ];
    }

    return heavyDuty ? ['RWD / 4x2', '4WD / 4x4'] : ['RWD / 4x2', '4WD / 4x4', 'Auto 4WD'];
  }

  function gmSuvDrives(ctx) {
    var group = clean(ctx.groupId);
    var premium = modelHas(ctx, ['denali', 'escalade']);

    if (group === 'gen3 gm truck suv') {
      if (premium && ctx.year >= 2002) return ['AWD / Full-Time — BW 4481 (NR3)'];
      return ['RWD / 4x2', 'Auto 4WD — NVG 246 (NP8 AutoTrac)'];
    }

    if (group === 'gen4 gm truck suv') {
      if (premium) {
        var premiumDrives = ['AWD / Full-Time — MP 3010 (NP0)'];
        if (ctx.year >= 2010 && modelHas(ctx, ['escalade'])) premiumDrives.unshift('RWD / 4x2');
        return premiumDrives;
      }
      return ['RWD / 4x2', 'Auto 4WD — MP 3023/3024 (NQH AutoTrac)'];
    }

    if (group === 'gen5 gm truck suv') {
      return ['RWD / 4x2', 'Auto 4WD — NQH 2-Speed AutoTrac'];
    }

    if (group === 'gen5 gm truck suv 2019 plus') {
      return ['RWD / 4x2', 'Auto 4WD — NQH 2-Speed Active'];
    }

    return ['RWD / 4x2', '4WD / 4x4'];
  }

  function gmOptions(ctx) {
    var y = ctx.year;
    var sixLiter = engineHas(ctx, ['6.0l', 'lq4', 'lq9', 'ly6', 'l76', 'l96', 'ls2']);
    var bigGasHd = engineHas(ctx, ['6.6l l8t', 'l8t']);
    var fallbackDrives = [];

    if (modelHas(ctx, ['silverado 2500', 'silverado 3500', 'sierra 2500', 'sierra 3500'])) {
      if (y >= 2024) return result(['10-Speed HD Automatic'], gmPickupDrives(ctx, true));
      if (y >= 2019) return result(['6L90', '10-Speed HD Automatic'], gmPickupDrives(ctx, true));
      if (y >= 2007) return result(['6L90'], gmPickupDrives(ctx, true));
      return result(['4L80E', 'NV4500 Manual'], gmPickupDrives(ctx, true));
    }

    if (modelHas(ctx, ['silverado', 'sierra'])) {
      if (y >= 2023) return result(['10L80'], gmPickupDrives(ctx, false));
      if (y >= 2019) return result(['6L80', '8L90', '10L80'], gmPickupDrives(ctx, false));
      if (y >= 2014) return result(['6L80', '8L90'], gmPickupDrives(ctx, false));
      if (y >= 2007) return result(['4L60E', '4L70E', '6L80'], gmPickupDrives(ctx, false));
      if (y >= 2001) return result(sixLiter ? ['4L60E', '4L65E', '4L70E', '4L80E', 'NV3500 Manual'] : ['4L60E', '4L65E', '4L70E', 'NV3500 Manual'], gmPickupDrives(ctx, sixLiter));
      return result(sixLiter ? ['4L60E', '4L80E', 'NV3500 Manual'] : ['4L60E', 'NV3500 Manual'], gmPickupDrives(ctx, sixLiter));
    }

    if (modelHas(ctx, ['tahoe', 'suburban', 'yukon', 'escalade'])) {
      var drives = gmSuvDrives(ctx);
      if (y >= 2021) return result(['10L80'], drives);
      if (y >= 2015) return result(['6L80', '8L90', '10L80'], drives);
      if (y >= 2007) return result(['4L60E', '6L80'], drives);
      return result(sixLiter || modelHas(ctx, ['suburban']) ? ['4L60E', '4L65E', '4L80E'] : ['4L60E', '4L65E'], drives);
    }

    if (modelHas(ctx, ['avalanche'])) {
      if (y >= 2007) return result(['4L60E', '6L80'], ['RWD / 4x2', 'Auto 4WD — MP 3023/3024 (NQH AutoTrac)']);
      return result(['4L60E', '4L65E', '4L80E'], ['RWD / 4x2', 'Auto 4WD — NVG 246 (NP8 AutoTrac)']);
    }

    if (modelHas(ctx, ['trailblazer ss'])) return result(['4L70E'], ['RWD / 4x2', 'AWD / Full-Time — NVG 120 (NR9)']);
    if (modelHas(ctx, ['9 7x aero'])) return result(['4L70E'], ['AWD / Full-Time — NVG 120 (NR9)']);
    if (modelHas(ctx, ['trailblazer'])) return result(engineHas(ctx, ['6.0l', 'ls2']) ? ['4L70E'] : ['4L60E'], ['RWD / 4x2', '4WD / 4x4 — NVG 226 (NP8 Active 2-Speed)'], false);
    if (modelHas(ctx, ['9 7x'])) return result(engineHas(ctx, ['6.0l', 'ls2']) ? ['4L70E'] : ['4L60E'], ['AWD / Full-Time — NVG 126 (NP4)'], false);
    if (modelHas(ctx, ['rainier', 'bravada'])) return result(['4L60E'], ['AWD / Full-Time — NVG 126 (NP4)'], false);
    if (modelHas(ctx, ['envoy'])) return result(['4L60E'], ['RWD / 4x2', '4WD / 4x4 — NVG 226 (NP8 Active 2-Speed)', 'AWD / Full-Time — NVG 126 (NP4)'], false);
    if (modelHas(ctx, ['ascender'])) return result(['4L60E'], ['RWD / 4x2', '4WD / 4x4 — NVG 226 (NP8 Active 2-Speed)'], false);

    if (modelHas(ctx, ['hummer h2', 'h2'])) {
      return y >= 2008 ? result(['6L80'], ['Full-Time 4WD — BW 4484']) : result(['4L65E'], ['Full-Time 4WD — BW 4484']);
    }
    if (modelHas(ctx, ['hummer h3', 'h3 alpha'])) return result(['4L60E'], ['Full-Time 4WD — BW 4493 / BW 4494']);

    if (modelHas(ctx, ['ssr'])) {
      return y >= 2005 ? result(['4L65E', 'T56 6-Speed Manual'], ['RWD']) : result(['4L60E'], ['RWD']);
    }

    if (modelHas(ctx, ['camaro zl1'])) {
      if (y >= 2019) return result(['10L90', 'TR6060 6-Speed Manual'], ['RWD']);
      if (y >= 2017) return result(['10L90', 'TR6060 6-Speed Manual'], ['RWD']);
      return result(['6L90', 'TR6060 6-Speed Manual'], ['RWD']);
    }
    if (modelHas(ctx, ['camaro ss', 'camaro'])) {
      if (y >= 2019) return result(['10L80', 'TR6060 6-Speed Manual'], ['RWD']);
      if (y >= 2016) return result(['8L90', 'TR6060 6-Speed Manual'], ['RWD']);
      if (y >= 2010) return result(['6L80', 'TR6060 6-Speed Manual'], ['RWD']);
      return result(['4L60E', 'T56 6-Speed Manual'], ['RWD']);
    }

    if (includesAny(ctx.make, ['holden', 'hsv'])) {
      var holdenDrives = ['RWD / 4x2'];
      if (y >= 2009) return result(['6L80', 'TR6060 6-Speed Manual'], holdenDrives, false);
      if (y >= 2006) return result(['6L80', 'T56 6-Speed Manual', 'TR6060 6-Speed Manual'], holdenDrives, false);
      if (engineHas(ctx, ['6.0l', 'ls2'])) return result(['4L65E', 'T56 6-Speed Manual'], holdenDrives, false);
      return result(['4L60E', '4L65E', 'T56 6-Speed Manual'], holdenDrives, false);
    }

    if (modelHas(ctx, ['firebird', 'trans am'])) return result(['4L60E', 'T56 6-Speed Manual'], ['RWD']);
    if (modelHas(ctx, ['pontiac gto', 'gto'])) return y >= 2005 ? result(['4L65E', 'T56 6-Speed Manual'], ['RWD']) : result(['4L60E', 'T56 6-Speed Manual'], ['RWD']);
    if (modelHas(ctx, ['g8 gxp'])) return result(['6L80', 'TR6060 6-Speed Manual'], ['RWD']);
    if (modelHas(ctx, ['g8 gt', 'g8'])) return result(['6L80'], ['RWD']);
    if (modelHas(ctx, ['chevrolet ss'])) return result(['6L80', 'TR6060 6-Speed Manual'], ['RWD']);
    if (modelHas(ctx, ['caprice'])) return result(['6L80'], ['RWD']);

    if (modelHas(ctx, ['corvette'])) {
      if (y >= 2020) return result(['M1L / M1-Family 8-Speed DCT'], ['RWD']);
      if (y >= 2015) return result(['8L90', 'TR6070 7-Speed Manual'], ['RWD']);
      if (y === 2014) return result(['6L80', 'TR6070 7-Speed Manual'], ['RWD']);
      if (y >= 2008) return result(['6L80', 'TR6060 6-Speed Manual'], ['RWD']);
      if (y >= 2006) return result(['6L80', 'T56 6-Speed Manual'], ['RWD']);
      if (y === 2005) return result(['4L65E', 'T56 6-Speed Manual'], ['RWD']);
      return result(['4L60E', 'T56 6-Speed Manual'], ['RWD']);
    }

    if (modelHas(ctx, ['ct5 v blackwing'])) return result(['10-Speed Automatic', 'TR6060 6-Speed Manual'], ['RWD']);
    if (modelHas(ctx, ['cts v'])) {
      if (y >= 2016) return result(['8L90'], ['RWD']);
      if (y >= 2009) return result(['6L90', 'TR6060 6-Speed Manual'], ['RWD']);
      return result(['T56 6-Speed Manual'], ['RWD']);
    }
    if (modelHas(ctx, ['sts v'])) return result(['6L80'], ['RWD']);
    if (modelHas(ctx, ['xlr v'])) return result(['6L80'], ['RWD']);
    if (modelHas(ctx, ['xlr'])) return y >= 2007 ? result(['6L80'], ['RWD']) : result(['5L50E'], ['RWD']);

    if (modelHas(ctx, ['impala ss', 'monte carlo ss', 'grand prix gxp', 'lacrosse super'])) return result(['4T65E-HD'], ['FWD']);

    if (modelHas(ctx, ['express', 'savana'])) {
      if (y >= 2024 && bigGasHd) return result(['8-Speed HD Automatic'], ['RWD / 4x2'], false);
      if (y >= 2018 && engineHas(ctx, ['4.3l', 'lv1'])) return result(['8L90'], ['RWD / 4x2'], false);
      if (y >= 2014) return result(bigGasHd ? ['6L90'] : ['6L80', '6L90'], ['RWD / 4x2'], false);
      if (y >= 2007) return result(['4L60E', '4L80E', '6L90'], ['RWD / 4x2'], false);
      return result(['4L60E', '4L80E'], ['RWD / 4x2'], false);
    }

    return result([], [], false);
  }

  function moparOptions(ctx) {
    var y = ctx.year;
    var hellcat = engineHas(ctx, ['6.2l supercharged', 'hellcat']);
    var sixFour = engineHas(ctx, ['6.4l', '392', 'apache']);
    var sixOne = engineHas(ctx, ['6.1l']);
    var fallbackDrives = [];

    if (modelHas(ctx, ['ram trx'])) return result(['ZF 8HP95'], ['Full-Time 4WD']);

    if (y <= 2012 && modelIs(ctx, ['Ram Sport', 'Ram R/T', 'Ram Outdoorsman', 'Ram Laramie', 'Ram Longhorn', 'Ram Tradesman', 'Ram Fleet'])) {
      return result(y >= 2012 ? ['65RFE'] : ['545RFE'], modelIs(ctx, ['Ram R/T']) ? ['RWD / 4x2'] : ['RWD / 4x2', '4WD / 4x4'], false);
    }

    if (modelIs(ctx, ['Ram Tradesman HEMI', 'Ram Fleet'])) {
      return result(['65RFE', 'ZF / TorqueFlite 8HP70', '66RFE', 'Aisin AS66RC'], ['RWD / 4x2', '4WD / 4x4', 'Auto 4WD'], false);
    }

    if (modelHas(ctx, ['ram 2500', 'ram 3500', 'ram 4500', 'ram 5500', 'chassis cab', 'power wagon'])) {
      var hdDrives = modelHas(ctx, ['power wagon']) ? ['4WD / 4x4'] : ['RWD / 4x2', '4WD / 4x4'];
      if (y >= 2019) return result(['ZF / TorqueFlite 8HP75 HD'], hdDrives);
      if (y >= 2014) return result(modelHas(ctx, ['ram 4500', 'ram 5500', 'chassis cab']) ? ['66RFE', 'Aisin AS66RC'] : ['66RFE'], hdDrives);
      return result(['545RFE', '66RFE'], hdDrives, false);
    }

    if (modelHas(ctx, ['ram 1500'])) {
      if (y >= 2019) return result(['ZF / TorqueFlite 8HP75'], ['RWD / 4x2', '4WD / 4x4', 'Auto 4WD']);
      if (y >= 2013) return result(['65RFE', 'ZF / TorqueFlite 8HP70'], ['RWD / 4x2', '4WD / 4x4', 'Auto 4WD']);
      return result(['545RFE', '65RFE'], ['RWD / 4x2', '4WD / 4x4', 'Auto 4WD']);
    }

    if (modelHas(ctx, ['challenger'])) {
      if (y >= 2015) {
        if (hellcat) return result(['ZF 8HP90', 'TR6060 6-Speed Manual'], ['RWD']);
        return result(['ZF / TorqueFlite 8HP70', 'TR6060 6-Speed Manual'], ['RWD']);
      }
      if (sixOne || sixFour) return result(['NAG1 / W5A580', 'TR6060 6-Speed Manual'], ['RWD']);
      return result(['NAG1 / W5A580', 'TR6060 6-Speed Manual'], ['RWD']);
    }

    if (modelHas(ctx, ['charger'])) {
      if (y >= 2015) {
        if (hellcat) return result(['ZF 8HP90'], ['RWD']);
        return result(['ZF / TorqueFlite 8HP70'], modelHas(ctx, ['pursuit']) && !sixFour ? ['RWD / 4x2', 'AWD / Full-Time'] : ['RWD / 4x2']);
      }
      return result(['NAG1 / W5A580'], sixOne || sixFour ? ['RWD / 4x2'] : ['RWD / 4x2', 'AWD / Full-Time']);
    }

    if (modelIs(ctx, ['300', '300 Limited HEMI', '300 Glacier Edition'])) {
      return result(y >= 2015 ? ['ZF / TorqueFlite 8HP70'] : ['NAG1 / W5A580'], y >= 2015 ? ['RWD / 4x2'] : ['RWD / 4x2', 'AWD / Full-Time'], false);
    }

    if (modelHas(ctx, ['chrysler 300', '300c', '300 srt', '300s'])) {
      if (y >= 2015) return result(['ZF / TorqueFlite 8HP70'], ['RWD / 4x2']);
      if (modelHas(ctx, ['300c awd'])) return result(['NAG1 / W5A580'], ['AWD / Full-Time']);
      return result(['NAG1 / W5A580'], sixOne || sixFour ? ['RWD / 4x2'] : ['RWD / 4x2', 'AWD / Full-Time']);
    }

    if (modelHas(ctx, ['magnum'])) return result(['NAG1 / W5A580'], sixOne ? ['RWD / 4x2'] : ['RWD / 4x2', 'AWD / Full-Time']);

    if (modelHas(ctx, ['grand cherokee trackhawk'])) return result(['ZF 8HP95'], ['AWD / Full-Time']);
    if (modelHas(ctx, ['grand cherokee srt'])) return y >= 2014 ? result(['ZF 8HP70'], ['AWD / Full-Time']) : result(['NAG1 / W5A580'], ['AWD / Full-Time']);
    if (modelHas(ctx, ['grand cherokee'])) {
      if (y >= 2014) return result(['ZF 8HP70'], ['RWD / 4x2', '4WD / 4x4']);
      return result(['545RFE', '65RFE'], ['RWD / 4x2', '4WD / 4x4']);
    }

    if (modelHas(ctx, ['commander'])) return result(['545RFE'], ['RWD / 4x2', '4WD / 4x4']);
    if (modelHas(ctx, ['aspen hybrid'])) return result(['Two-Mode Hybrid EVT'], ['4WD / 4x4']);
    if (modelHas(ctx, ['aspen'])) return result(['545RFE'], ['RWD / 4x2', '4WD / 4x4']);

    if (modelHas(ctx, ['durango hellcat'])) return result(['ZF 8HP95'], ['AWD / Full-Time']);
    if (modelHas(ctx, ['durango srt'])) return result(['ZF 8HP70'], ['AWD / Full-Time']);
    if (modelHas(ctx, ['durango'])) {
      if (y >= 2014) return result(['ZF 8HP70'], ['RWD / 4x2', 'AWD / Full-Time']);
      return result(['545RFE', '65RFE'], ['RWD / 4x2', 'AWD / Full-Time']);
    }

    if (modelHas(ctx, ['wrangler', 'rubicon 392'])) return result(['ZF / TorqueFlite 8HP75'], ['4WD / 4x4']);
    if (modelHas(ctx, ['grand wagoneer'])) return result(['ZF / TorqueFlite 8HP75'], ['4WD / 4x4']);
    if (modelHas(ctx, ['wagoneer'])) return result(['ZF / TorqueFlite 8HP75'], ['RWD / 4x2', '4WD / 4x4']);

    return result([], [], false);
  }

  function getOptions(input) {
    var ctx = {
      year: yearOf(input && input.year),
      make: String((input && input.make) || ''),
      model: String((input && input.model) || ''),
      engine: String((input && input.engine) || ''),
      groupId: String((input && input.groupId) || '')
    };
    if (isGM(ctx.make)) return gmOptions(ctx);
    if (isMopar(ctx.make)) return moparOptions(ctx);
    return result([], [], false);
  }

  function replaceOptions(select, values, placeholder, preserve) {
    if (!select) return;
    var previous = preserve ? select.value : '';
    select.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);
    (values || []).forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
    if (previous && Array.prototype.some.call(select.options, function (option) { return option.value === previous; })) select.value = previous;
  }

  function applyToSelects(transmissionSelect, drivetrainSelect, input, settings) {
    settings = settings || {};
    var options = getOptions(input || {});
    replaceOptions(transmissionSelect, options.transmissions, settings.transmissionPlaceholder || 'Select transmission...', settings.preserve !== false);
    replaceOptions(drivetrainSelect, options.drivetrains, settings.drivetrainPlaceholder || 'Select drivetrain...', settings.preserve !== false);
    if (typeof settings.disabled === 'boolean') {
      transmissionSelect.disabled = settings.disabled;
      drivetrainSelect.disabled = settings.disabled;
    }
    return options;
  }

  window.JRJ_POWERTRAIN_OPTIONS = {
    getOptions: getOptions,
    applyToSelects: applyToSelects
  };
})();
